import { h } from '../pragma.mjs';
import { settings } from '../../config/settingsFactory.mjs';
import { getValidSetting } from '../../utils/common.mjs';

export default (isPublic) => {

    return (
        <div>
            <div>
                <gov-breadcrumbs wcag-label="Úroveň zanoření v rozcestníku">
                    <ul class="breadcrumbs">
                        <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikRoot" href="#">Domů</a></li>
                        <li><gov-icon type="basic" name="chevron-right"></gov-icon><strong>Údaje z katastru a zeměměřictví</strong></li>
                    </ul>
                </gov-breadcrumbs>
            </div>
            
            <gov-tiles role="list">
                <gov-tile role="listitem" href={ isPublic ? getValidSetting(settings.urls?.DPN?.public,'#','DPN link public') : getValidSetting(settings.urls?.DPN?.private,'#','DPN link private')} target="_blank">
                    <p>Nákup elektronických listin, platba kartou nebo on-line bankovním převodem ( např. výpisy z KN, sbírka listin, přehled vlastnictví)</p>
                    <h3 slot="title">E-shop s údaji katastru&nbsp;<gov-icon class="h3icon" type="basic" name="box-arrow-up-right"></gov-icon></h3>
                    <gov-icon type="complex" name="doc-diploma" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile role="listitem" href={ isPublic ? getValidSetting(settings.urls?.NAH?.public,'#','NAH link public') : getValidSetting(settings.urls?.NAH?.private,'#','NAH link private')} target="_blank">
                    <p>Bezplatné nahlížení na údaje katastru</p>
                    <h3 slot="title">Nahlížení&nbsp;<gov-icon class="h3icon" type="basic" name="box-arrow-up-right"></gov-icon></h3>
                    <gov-icon type="complex" name="doc-search" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile id="ssz-link-tile" role="listitem" href={ isPublic ? getValidSetting(settings.urls?.SSZ?.public,'#','SSZ link public') : getValidSetting(settings.urls?.SSZ?.private,'#','SSZ link private')} target="_blank">
                    <p>Upozornění vlastníka na změnu v katastru</p>
                    <h3 slot="title">Služba sledování změn&nbsp;<gov-icon class="h3icon" type="basic" name="box-arrow-up-right"></gov-icon></h3>
                    <gov-icon type="complex" name="pet" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile href="#" id="zememerictviTile">
                    <p>Přístup k mapovým produktům a službám zeměměřického úřadu</p>
                    <h3 slot="title">Zeměměřictví</h3>
                    <gov-icon type="complex" name="doc-visa" slot="icon"></gov-icon>
                </gov-tile>
            </gov-tiles>
        </div>
    )

}